(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["montage-offer"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (root = document) => {
      root.querySelectorAll('[data-montage-dialog]').forEach((dialog) => {
        if (dialog.dataset.montageReady === 'true') return;
        dialog.dataset.montageReady = 'true';

        let opener = null;
        const triggers = document.querySelectorAll(`[aria-controls="${dialog.id}"]`);
        const closeDialog = () => {
          if (dialog.open) dialog.close();
        };

        dialog.querySelectorAll('[data-montage-source-url]').forEach((field) => {
          field.value = window.location.href;
        });

        triggers.forEach((trigger) => {
          trigger.addEventListener('click', () => {
            opener = trigger;
            dialog.showModal();
            document.documentElement.classList.add('montage-offer-open');
          });
        });

        dialog.querySelectorAll('[data-montage-close]').forEach((button) => {
          button.addEventListener('click', closeDialog);
        });

        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          const isInside = event.clientX >= bounds.left
            && event.clientX <= bounds.right
            && event.clientY >= bounds.top
            && event.clientY <= bounds.bottom;
          if (!isInside) closeDialog();
        });

        dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('montage-offer-open');
          if (opener) opener.focus();
        });

        if (dialog.querySelector('.montage-offer__success, .montage-offer__errors')) {
          dialog.showModal();
          document.documentElement.classList.add('montage-offer-open');
        }
      });
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
